import React, { useState, useEffect } from "react";
import { PackageColumns } from "./PackageData";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { useNavigate } from "react-router-dom";
import ConfirmationATM from "../../../../../../Common/ConfirmationATM";
import { toast } from "react-toastify";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";
import {
  hasDeleteAccess,
  hasEditAccess,
} from "../../../../../../Common/CheckAccess";

const PackagesTable = ({ setSelectedPackage, listUpdated, permissions }) => {
  const BaseUrl = getBaseUrl();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0); // use real total if API is used
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("Package name");
  const [islistDataLoading, isSetListDataLoading] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  const handleRoomStatusChange = (roomId, newStatus) => {};

  const handleDelete = (user) => {
    setShowDeleteDialog(true);
    setSelectedUser(user);
  };

  const fetchData = async () => {
    isSetListDataLoading(true);
    const params = new URLSearchParams();

    params.set("page", currentPage);
    params.set("limit", pageSize);

    if (gloablFilterType === "Package name") {
      params.set("name", globalFilter);
    } else if (gloablFilterType === "Room type") {
      params.set("room_type", globalFilter);
    }
    let token = localStorage.getItem("token");
    let hotel_id = localStorage.getItem("hotel_id");
    if(hotel_id){
      params.set("hotel_id", hotel_id);
    }


    await fetch(`${BaseUrl}/room/package/all?${params}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        const allPackages = response?.data?.data || [];
        const total = response?.data?.pagination?.totalResults || 0;
        setTotalEntries(total);
        const transformed = allPackages.map((data) => ({
          name: data.name,
          description: data.description,
          price: data.price,
          created_at: data.created_at?.split("T")[0],
          room_type: data.rooms?.map((itm) => itm.room_type).join(",") || "N/A",
          actions: (
            <>
              {(hasDeleteAccess(permissions, "rooms") ||
                hasDeleteAccess(permissions, "front_desk")) && (
                <button
                  className="btn"
                  data-toggle="modal"
                  data-target="#deleteGuest"
                  onClick={() => {
                    handleDelete(data);
                  }}
                >
                  <i className="bi bi-trash text-danger"></i>
                </button>
              )}
              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#add-package"
                aria-controls="add-package"
                className="btn"
                disabled={
                  !(
                    hasEditAccess(permissions, "rooms") ||
                    hasEditAccess(permissions, "front_desk")
                  )
                }
                onClick={() => setSelectedPackage(data)}
              >
                <i className="bi bi-pencil text-primary"></i>
              </button>
            </>
          ),
        }));

        setData(transformed);
        isSetListDataLoading(false);
      })
      .catch((err) => {
        console.error(err);
        isSetListDataLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [listUpdated, globalFilter, pageSize, currentPage,permissions]);

  const confirmDelete = () => {
    let token = localStorage.getItem("token");

    fetch(`${BaseUrl}/room/package/${selectedUser?.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        toast.success("Data deleted successfully !");
        setShowDeleteDialog(false);
        fetchData();
      })
      .catch((error) => {
        toast.error("Something went wrong !");
        setShowDeleteDialog(false);
      });
  };
  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setCurrentPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        filtersOptions={["Package name", "Room type"]}
        flage="packages"
      />

      <DataTable
        columns={PackageColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={islistDataLoading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      {
        <ConfirmationATM
          show={showDeleteDialog}
          onClose={() => {
            setShowDeleteDialog(false);
            setSelectedUser("");
          }}
          onConfirm={confirmDelete}
          message={`Are you sure you want to delete package ${selectedUser?.name} ?`}
        />
      }
    </>
  );
};

export default PackagesTable;
